import { Component, input } from '@angular/core';
import { LatestMeetingCardComponent } from './components/latest-meeting-card/latest-meeting-card.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { IHome_LatestMeeting } from '@shared/constants/models.const';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../../services/helper.service';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';
import { SeeAllComponent } from '@shared/components/see-all/see-all.component';
import { E_FOLDER_TYPES } from '@shared/constants/enums.const';
import { OnlyDate } from '@shared/pipes/only-date';

@Component({
  selector: 'app-latest-meetings-section',
  imports: [
    LatestMeetingCardComponent,
    TranslateModule,
    RemoveHtmlPipe,
    SeeAllComponent,
    OnlyDate,
  ],
  templateUrl: './latest-meetings-section.component.html',
  styleUrl: './latest-meetings-section.component.scss',
})
export class LatestMeetingsSectionComponent {
  meetings = input<IHome_LatestMeeting[]>([]);
  protected readonly ButtonTypes = BUTTON_TYPES;

  protected readonly E_FOLDER_TYPES = E_FOLDER_TYPES;

  getUrl(sourceUrl: string) {
    return this.HELPER.getUrl(sourceUrl);
  }

  constructor(
    public HELPER: HelperService,
  ) {
  }
}
